import script from "./PeriodToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodToggle.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodToggle.vue?vue&type=style&index=0&id=56365bae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56365bae"]])

export default __exports__